import { render, staticRenderFns } from "./EnquiryOverview.vue?vue&type=template&id=70f2940e&scoped=true"
import script from "./EnquiryOverview.vue?vue&type=script&lang=js"
export * from "./EnquiryOverview.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/dashboard.scss?vue&type=style&index=0&id=70f2940e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f2940e",
  null
  
)

export default component.exports